module.exports = __webpack_public_path__ + "./fonts/DMSans-MediumItalic.b5d9a9.woff2";